import React from "react";
import { RouteItemProps } from "@presentation/common/RouteItemProps";
import { JobListPage, JobSetupPage, AboutPage, SoftwareVersionsPage } from "@presentation/pages";
import { listUnorderedSquareIcon, plusOutlineIcon, infoSolidIcon, gearsIcon } from "@progress/kendo-svg-icons";

export const appRoutes: RouteItemProps[] = [
  {
    text: "Job List",
    route: "/",
    svgIcon: listUnorderedSquareIcon,
    element: <JobListPage />,
    selected: true,
    title: "View the list of jobs",
  },
  { separator: true },
  {
    text: "Job Setup",
    route: "/job-setup",
    svgIcon: plusOutlineIcon,
    element: <JobSetupPage />,
    title: "Create a new job",
  },
  { separator: true },
  {
    text: "Software Versions",
    route: "/software-versions",
    svgIcon: gearsIcon,
    element: <SoftwareVersionsPage />,
    title: "Manage allowed Spectronaut and SpectroMine versions",
  },
  { separator: true },
  {
    text: "About",
    route: "/about",
    svgIcon: infoSolidIcon,
    element: <AboutPage />,
    title: "About OmicsFlow",
  },
  { separator: true },
];
